import flow from 'lodash/fp/flow';
import { css } from 'emotion';
import facepaint from 'facepaint';
import { precision, breakpoints } from '../utils/presets';
import { options } from '../utils/typography';

const round = flow([parseFloat, x => x.toFixed(precision)]);

// Convert pixel values to rem units
const toRem = x => {
  const { baseFontSize } = options;
  return `${round(parseFloat(x) / parseFloat(baseFontSize))}rem`;
};

// Convert pixel values to viewport width units
const toVW = x => {
  const viewportWidth = 1920;
  return `${round(parseFloat(x) / viewportWidth * 100)}vw`;
};

// facepaint
const fp = facepaint(
  Object.values(breakpoints)
    .filter(bp => Number.isInteger(bp))
    .map(bp => `@media (min-width: ${bp}px)`)
);

// Reusable media queries with object styles
const mqObj = Object.keys(breakpoints).reduce((accumulator, label) => {
  const bp = breakpoints[label];
  const prefix = typeof bp === 'string' ? '' : 'min-width: ';
  const suffix = typeof bp === 'string' ? '' : 'px';
  accumulator[label] = `@media (${prefix + bp + suffix})`;
  return accumulator;
}, {});

// Reusable media queries with string styles
const mqString = Object.keys(breakpoints).reduce((accumulator, label) => {
  const prefix = typeof breakpoints[label] === 'string' ? '' : 'min-width: ';
  const suffix = typeof breakpoints[label] === 'string' ? '' : 'px';
  accumulator[label] = cls =>
    css`
      @media (${prefix + breakpoints[label] + suffix}) {
        ${cls};
      }
    `;
  return accumulator;
}, {});

export default {
  toRem,
  toVW,
  fp,
  mqObj,
  mqString,
};



// WEBPACK FOOTER //
// ./src/utils/functions.js